import { useInitialLoading } from '../hooks/useInitialLoading';
import React, { useState, useEffect, useCallback } from 'react';
import { getAuthHeaders } from '../utils/authHeaders';
import { API, StateCard, tableStyle, thStyle, tdStyle } from './RpShared';

export default function RpOverview() {
  const companyId = localStorage.getItem('selectedCompanyId');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const initialLoading = useInitialLoading(loading);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/companies/${companyId}/roles-permissions/overview`, { headers: getAuthHeaders() });
      if (!res.ok) throw new Error('Failed');
      setData(await res.json());
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [companyId]);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (initialLoading || !data) return <div style={{ padding: 32, textAlign: 'center' }}>Loading...</div>;

  return (
    <div style={{ padding: '24px 32px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#1a1a2e' }}>🔐 Roles & Permissions Overview</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 14 }}>
        <StateCard label="Total Permissions" count={data.total_permissions} color="#3b82f6" icon="🗂️" />
        <StateCard label="Modules Covered" count={data.total_modules} color="#8b5cf6" icon="🧩" />
        <StateCard label="Company Users" count={data.user_count} color="#10b981" icon="👤" />
        <StateCard label="Sensitive Permissions" count={data.sensitive_permissions} color="#ef4444" icon="⚠️" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 20 }}>
        <StateCard label="Positions with Presets" count={data.positions_with_presets} color="#f59e0b" icon="🧭" />
        <StateCard label="Active Scope Grants" count={data.active_grants} color="#06b6d4" icon="✅" />
        <StateCard label="Active Temporary Grants" count={data.temporary_active} color="#ec4899" icon="⏳" />
      </div>

      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 18 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', marginBottom: 12 }}>Permission Catalog by Module</div>
        <div style={{ overflowX: 'auto' }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Module</th>
                <th style={thStyle}>Submodules</th>
                <th style={thStyle}>Permissions</th>
              </tr>
            </thead>
            <tbody>
              {(data.modules || []).map((m) => (
                <tr key={m.module_key}>
                  <td style={tdStyle}>{m.module_name}</td>
                  <td style={tdStyle}>{m.submodule_count}</td>
                  <td style={tdStyle}>{m.permission_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
